module.exports = __webpack_public_path__ + "static/media/elife-school-2024-6.ab019187.gif";